<!-- 我的账户-重置密码 -->
<template>
  <div class="common-box border-t0">
    <el-form :model="formOne" :rules="formOneRules" ref="formOneRef" label-width="110px" label-position="right" class="form-single">
      <el-form-item label="手机号：" prop="phone">
        <el-input v-model="formOne.phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="手机验证码：" prop="code" :error="codeError">
        <el-input v-model="formOne.code" placeholder="请输入手机验证码" style="border-radius:3px 0 0 3px;">
          <el-button type="code" :disabled="codeDisable" slot="append" @click="getCode">
            <span v-show="sendAuthCode">{{this.codefont == '0'? '获取验证码':'重新获取'}}</span>
            <span v-show="!sendAuthCode">{{auth_time}} 秒</span>
          </el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPsw">
        <el-input type="password" v-model="formOne.newPsw" placeholder="请输入新密码" @input="formOne.newPsw = formOne.newPsw.trim()" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="sureNewPsw" :error="errorMessage">
        <el-input type="password" v-model="formOne.sureNewPsw" placeholder="请再次确认新密码" @input="formOne.sureNewPsw = formOne.sureNewPsw.trim()" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <p class="el-form-item__error warnColor" style="line-height:1.3">注：密码长度为6-8位，不能含有3个及以上重复相同、连续数字或字母、空格或着汉字</p>
      </el-form-item>
      <el-form-item>
        <el-button type="normal" class="margin-t50" @click="submit">修改密码</el-button>
      </el-form-item>
    </el-form>
    <!-- 密码修改成功弹框 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable" :show-close="false" :close-on-click-modal="false">
      <img src="../../assets/images/status1.png" alt="" width="60">
      <p class="dialog-single-one-p" style="padding: 0px 48px;">恭喜，您的密码已被修改，请采用新的密码进行登录</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="loginAgain">重新登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  data () {
    var validatePass1 = (rule, value, callback) => {
      var req = /(\w)\1{2}/;
      var reString = /^[\u4E00-\u9FA5]+$/;
      if (value.search(req) != -1) {
        callback(new Error('密码内不能含有3个连续相同的字符！'));
      } else if (!this.$commonJs.checkSeries(value)) {
        callback(new Error('密码不能有三个以上(含三个)的连续数字或字母！'));
      } else if (reString.test(value)) {
        callback(new Error('密码不能有汉字！'));
      } else {
        if (this.formOne.sureNewPsw !== '') {
          this.$refs.formOneRef.validateField('sureNewPsw');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.formOne.newPsw) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      formOne: {
        phone: '',
        code: '',
        newPsw: '',
        sureNewPsw: '',
      },
      dialogVisable: false,
      errorMessage: '',
      formOneRules: {
        newPsw: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码长度为6-8位', trigger: 'blur' },
          { validator: validatePass1, trigger: 'blur' }
        ],
        sureNewPsw: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码长度为6-8位', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          //   { validator: validateNum, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '请输入六位短信验证码', trigger: 'blur' }
        ],
      },
      // 验证码
      codeError: '',
      auth_time: 0,
      codeDisable: false,
      sendAuthCode: true,
      codefont: 0,
    }
  },
  methods: {
    loginAgain () {
      this.$commonJs.logout()
      this.$router.push({ name: 'login' })
    },
    // 修改密码
    submit () {
      this.errorMessage = ''
      this.$refs.formOneRef.validate(valid => {
        if (!valid) return
        if (this.formOne.code == this.$commonJs.getCookie('note')) {
          this.$http.post(this.$apiPath.resetInvestmentAdviserPassword, {
            AdviserCode: this.$commonJs.getCookie('code'),
            NewPassword: this.formOne.newPsw
          }).then(res => {
            // console.log(res);
            if (res.data.code == 200 && res.data.data.note == "提交成功") {
              this.dialogVisable = true
            } else if (res.data.code == 601) {
              this.errorMessage = '原密码输入错误'
            } else {
              this.errorMessage = '密码修改失败'
            }
          }).catch(err => { })
        } else {
          this.$nextTick(() => {
            this.errorMessage = '验证码输入错误！'
          })
        }

      })
    },
    // 获取验证码
    getCode () {
      this.codeError = ''
      if (this.formOne.phone == '') {
        this.codeError = '请完善手机号再尝试获取验证码'
      } else {
        let phoneRight = this.$commonJs.getCookie('adviserPnone')
        if (this.formOne.phone !== phoneRight) {
          this.codeError = '请输入绑定您账户的手机号'
        } else {
          this.codeError = ''
          // 发送验证码
          this.$http.post(this.$apiPath.getNoteCode, {
            AdviserCode: this.$commonJs.getCookie('code'),
            Phone: this.formOne.phone,
          }).then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              const note = res.data.data.noteCode
              var exp = new Date();
              exp.setTime(exp.getTime() + 2 * 60 * 1000);//两分钟
              document.cookie = "note=" + note + ";path=/;expires=" + exp.toGMTString();
              this.counter()
            } else {
              this.$message.error('验证码获取失败')
            }
          }).catch(err => { })
        }
      }
    },
    // 验证码计时
    counter () {
      this.codeDisable = true
      this.sendAuthCode = false;
      this.auth_time = 120;
      var auth_timetimer = setInterval(() => {
        if (this.auth_time == 0) {
          this.sendAuthCode = true;
          this.codeDisable = false
          clearInterval(auth_timetimer);
          this.codefont = 1
        } else {
          this.codefont = 0
          this.auth_time--;
        }
      }, 1000);
    },
  }
}
</script>

<style scoped>
</style>
